import {FileEntry} from '@app/core/models/fileEntry.model';
import {IQOPagination} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-pagination.interface';

export interface IFileEntryState {
	uploadedFiles: FileEntry[];
	fileEntries: FileEntry[];
	isLoading: boolean;
	pagination: IQOPagination;
}

export const initialFileEntryState: IFileEntryState = {
	uploadedFiles: [],
	fileEntries: [],
	isLoading: false,
	pagination: null,
};
